//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQButton from "@/components/Generics/AQButton/AQButton.vue";

const localStreams = [];
let recorder;

export default {
    name: "VideoCapture",
    components: {
        AQButton
    },
    props: {
        stopBtn: { type: Boolean, default: false },
        timeVideo: { type: Number, default: 10 },
        devices: { type: Array, default: () => [] },
        range: { type: Object, default: () => {} }
    },
    data() {
        return {
            countdown: 0,
            time: null,
            showVideo: false,
            recording: false,
            retake: false,
            cancelVideo: false,
            deviceId: null,
            canStop: false

        };
    },
    mounted() {
        this.streamUserMediaVideo();
    },
    beforeDestroy() {
        localStreams.forEach(stream => {
            if (stream.active) {
                stream.getVideoTracks().forEach(track => track.stop());
            }
        });

        this.close();
    },
    methods: {
        streamUserMediaVideo(id) {
            this.deviceId = id || this.devices[0].deviceId;
            localStreams.splice(0, localStreams.length);
            navigator.mediaDevices
                .getUserMedia({ video: {
                    width: { ideal: 1280, max: 1280 },
                    height: { ideal: 720, max: 720 },
                    frameRate: { max: 30 },
                    deviceId: this.deviceId
                } })
                .then(stream => {
                    localStreams.push(stream);
                    this.$refs.preview.srcObject = stream;
                })
                .catch((err) => err && this.$emit("cameraIsUsed", true));
        },

        switchCamera() {
            if (this.devices.length && !this.recording) {
                const indexId = this.devices.findIndex(element => element.deviceId === this.deviceId);
                if (indexId < this.devices.length - 1) {
                    const nextDevice = indexId + 1;
                    this.streamUserMediaVideo(this.devices[nextDevice].deviceId);
                } else {
                    this.streamUserMediaVideo(this.devices[0].deviceId);
                }
            }
        },
        close() {
            const closeTracks = stream => stream.getTracks().forEach(track => track.stop());
            const { preview, recording } = this.$refs;
            if (preview && preview.srcObject) {
                closeTracks(preview.srcObject);
            }
            if (recording && recording.srcObject) {
                closeTracks(recording.srcObject);
            }
        },
        onStartRecording() {
            this.cancelVideo = false;
            navigator.mediaDevices.getUserMedia({ video: {
                width: { ideal: 1280, max: 1280 },
                height: { ideal: 720, max: 720 },
                frameRate: { max: 30 },
                deviceId: this.deviceId
            } }).then(stream => {
                localStreams.push(stream);
                this.$refs.preview.srcObject = stream;
                return new Promise(resolve => this.$refs.preview.onplaying = resolve);
            })
                .then(() => new Promise((resolve) => {
                    const { captureStream, mozCaptureStream } = this.$refs.preview;
                    if (captureStream) {
                        this.recordStream(this.$refs.preview.captureStream()).then((recordedChunks) => {
                            resolve(recordedChunks);
                        });
                    } else if (mozCaptureStream) {
                        this.recordStream(this.$refs.preview.mozCaptureStream()).then((recordedChunks) => {
                            resolve(recordedChunks);
                        });
                    }
                }))
                .then(recordedChunks => {
                    const { recording } = this.$refs;
                    if (recording) {
                        const recordedBlob = new Blob(recordedChunks, { type: "video/webm" });
                        this.$emit("sendBlob", recordedBlob);
                        recording.src = URL.createObjectURL(recordedBlob);
                    }
                })
                .catch();
        },
        recordStream(stream) {
            localStreams.push(stream);
            this.$emit("recordingStarted", true);
            clearInterval(this.time);
            if (this.range && this.range.max) {
                this.countdown = this.range.max;
            } else if (this.timeVideo) {
                this.countdown = this.timeVideo;
            } else {
                this.countdown = 10;
            }
            this.time = null;
            this.startCountdown();
            this.showVideo = false;
            this.recording = true;
            recorder = new MediaRecorder(stream);
            const data = [];
            recorder.ondataavailable = event => data.push(event.data);
            recorder.start();
            const stopped = new Promise((resolve, reject) => {
                recorder.onstop = resolve;
                recorder.onerror = event => reject(event.name);
            }).then((val) => {
                if (val.type === "stop" && !this.cancelVideo) {
                    this.showVideo = true;
                    this.recording = false;
                    this.retake = true;
                }
            });
            return Promise.all([stopped]).then(() => data);
        },
        resetVideo() {
            if (recorder.state === "recording") {
                recorder.stop();
            }
            this.$emit("sendBlob", null);
            this.cancelVideo = true;
            this.showVideo = false;
            this.retake = false;
            this.recording = false;
            clearInterval(this.time);
            this.countdown = 0;
            this.canStop = false;
        },
        stopVideo() {
            if (recorder && recorder.state === "recording") {
                recorder.stop();
            }
            this.countdown = 0;
        },
        startCountdown() {
            let diff = null;
            if (this.range && this.range.max) {
                diff = this.range.max - this.range.min;
            }
            this.time = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                    if (diff && this.countdown <= diff) {
                        this.canStop = true;
                    }
                } else {
                    if (recorder && recorder.state === "recording") {
                        recorder.stop();
                    }
                    this.canStop = false;
                    clearInterval(this.time);
                }
            }, 1000);
        },
        retakeVideo() {
            this.retake = false;
            this.showVideo = false;
        }
    }
};
